import { MuiTypography } from '@/features/shared/material-ui';
import React, { PropsWithChildren } from 'react';
import { ToggleGroupProps } from './ToggleGroup.interface';
import useStyles from './ToggleGroup.styles';

const ToggleGroup = (props: PropsWithChildren<Partial<ToggleGroupProps>>) => {
  const classes = useStyles({});

  return (
    <div>
      {!!props?.title && (
        <MuiTypography component="h3" variant="caption" className={classes.title}>
          <strong>{props.title}</strong>
        </MuiTypography>
      )}
      {!!props.description && (
        <MuiTypography component="p" variant="body2">
          {props.description}
        </MuiTypography>
      )}
      {props.children}
    </div>
  );
};

export default React.memo(ToggleGroup);
